import CohLanding from "@/pages/landing-page/cohLanding";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/coh")({
  component: CohLanding,
});
